// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { LocationType } from '@/location/api/types';

/**
 * Human-readable labels for location type values
 */
export const LOCATION_TYPE_LABELS: Record<LocationType, string> = {
  SITE: 'Site',
  ZONE: 'Zone',
};
